var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MUTATION_TYPES } from "../../lib/mutationTypes";
import Vue from 'vue';
import { Environment } from "../../lib/environment";
import { WalletsHelper } from "../../lib/storage";
export default Vue.extend({
    name: "WalletBar",
    props: {
        isOpened: Boolean,
        id: {
            type: String,
            default: ""
        },
        value: {
            type: Boolean,
            default: true
        },
        icon: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            walletName: ''
        };
    },
    methods: {
        onClickWallet() {
            if (this.isOpened) {
                if (Environment.isIos() && Environment.isInStandaloneMode()) {
                    this.$router.push(this.$store.state.backPathFromWalletSelect);
                }
                else {
                    this.$router.go(-1);
                }
            }
            else {
                this.$store.commit(MUTATION_TYPES.SET_BACK_PATH_FROM_WALLET_SELECT, this.$router.currentRoute.fullPath);
                this.$router.push('/wallet/select');
            }
        },
        refresh() {
            return __awaiter(this, void 0, void 0, function* () {
                this.walletName = yield this.getWalletName();
                this.$emit('input', false);
            });
        },
        getWalletName() {
            return __awaiter(this, void 0, void 0, function* () {
                const wallet = yield this.getTargetWallet();
                if (wallet === null) {
                    return this.$t('common.not_select').toString();
                }
                else {
                    return wallet.name;
                }
            });
        },
        getTargetWallet() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.id.length == 0) {
                    return yield WalletsHelper.getActive();
                }
                else {
                    return yield WalletsHelper.get(this.id);
                }
            });
        },
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.refresh();
        });
    },
    watch: {
        value: function (needs) {
            return __awaiter(this, void 0, void 0, function* () {
                if (needs) {
                    yield this.refresh();
                }
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/WalletBar.vue
// module id = 322
// module chunks = 1